import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'glo-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  imports: [NgClass, NgFor, NgIf]
})
export class GloPaginationComponent {
  // Total number of items to paginate
  @Input() totalItems: number = 0;
  // Current page number (1-based)
  @Input() currentPage: number = 1;
  // Number of items to show per page
  @Input() itemsPerPage: number = 10;
  // Options for the items per page dropdown
  @Input() itemsPerPageOptions: number[] = [10, 20, 50, 100];

  // Emitted when page changes
  @Output() currentPageChange = new EventEmitter<number>();
  // Emitted when items per page changes
  @Output() itemsPerPageChange = new EventEmitter<number>();

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage) || 1;
  }

  Math = Math;

  onPageClick(page: number) {
    if (page !== this.currentPage) {
      this.currentPageChange.emit(page);
    }
  }

  goPrevious() {
    if (this.currentPage > 1) {
      this.currentPageChange.emit(this.currentPage - 1);
    }
  }

  goNext() {
    if (this.currentPage < this.totalPages) {
      this.currentPageChange.emit(this.currentPage + 1);
    }
  }

  // Handle items per page change
  onItemsPerPageChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    const value = Number(target.value);
    this.itemsPerPageChange.emit(value);
    // Reset to first page when page size changes
    this.currentPageChange.emit(1);
  }
}
